<template>
    <div>
        <button v-cloak v-show="following" @click="onClickUnfollow" :class="btnClass + ' btn-follow'" type="button" class="btn btn-light border-2 rounded-full font-semibold">
            <spinner :loading="loading" class="fa-lg" />
            <span v-cloak v-show="!loading">
                <!-- <fa-icon :icon="['fas', 'bell-slash']" class="mr-1" /> -->
                <i :class="iconClass" class="far fa-bell-slash fa-lg mr-1"></i>
                Unfollow
            </span>
        </button>

        <button v-cloak v-show="!following" @click="onClickFollow" :class="btnClass + ' btn-unfollow'" type="button" class="btn btn-light border-2 rounded-full font-semibold">
            <spinner :loading="loading" class="fa-lg" />
            <span v-cloak v-show="!loading">
                <!-- <fa-icon :icon="['fas', 'bell']" class="mr-1" /> -->
                <i :class="iconClass" class="far fa-bell-plus fa-lg mr-1"></i>
                {{ btnText || 'Follow' }}
            </span>
        </button>

        <portal v-if="showAuthModal" to="modals">
            <auth-modal v-if="showAuthModal" @authed="onUserAuth" @close="onAuthModalClosed" />
        </portal>
    </div>
</template>

<script>
export default {
    props: [
        'listing',
        'btn-class',
        'btn-text',
        'icon-class'
    ],

    data: () => ({
        loading: false,
        following: false,
        showAuthModal: false
    }),

    created() {
        const user = this.user;
        if (!user) {
            return;
        }

        const listingIds = this.app.user_listings;
        const listingId = this.listing.id;

        this.following = listingIds.includes(listingId);

        Echo.private('users.' + user.id)
            .listen(".listing.user_subscribed", e => {
                if (e.listing.id === this.listing.id) {
                    this.following = true;
                }
            })
            .listen(".listing.user_unsubscribed", e => {
                if (e.listing.id === this.listing.id) {
                    this.following = false;
                }
            });
    },

    mounted() {},

    computed: {},

    methods: {
        onUserAuth() {
            //
        },

        onAuthModalClosed() {
            this.showAuthModal = false;
        },

        onButtonClick($event) {
            $event.preventDefault();
            $event.stopPropagation();
        },

        onClickFollow($event) {
            $event.preventDefault();
            $event.stopPropagation();

            const listingId = this.listing.id;

            if (!this.user) {
                this.showAuthModal = true;
                // window.location.href = '/listings/' + listingId + '/follow';
                return;
            }

            this.followListing(listingId);
        },

        onClickUnfollow($event) {
            $event.preventDefault();
            $event.stopPropagation();

            const listingId = this.listing.id;

            if (!this.user) {
                this.showAuthModal = true;
                // window.location.href = '/listings/' + listingId + '/unfollow';
                return;
            }

            this.unfollowListing(listingId);
        },

        followListing(listingId) {
            this.loading = true;

            axios.post(`/api/listings/${listingId}/follow`)
                .then(response => {
                    // @todo trigger analytics event (listing_follow)

                    this.following = true;
                })
                .catch(response => {})
                .finally(() => {
                    this.loading = false;
                });
        },

        unfollowListing(listingId) {
            this.loading = true;

            axios.delete(`/api/listings/${listingId}/follow`)
                .then(response => {
                    // @todo trigger analytics event (listing_unfollow)

                    this.following = false;
                })
                .catch(response => {})
                .finally(() => {
                    this.loading = false;
                });
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
